import { useDispatch } from 'react-redux';
import { useSetRecoilState } from 'recoil';
import i18n from 'i18n';
import LANGUAGE from 'native/language';
import actionNames from 'native/action';
import { appVersionState } from 'native/store/appVersionState';
import {
  setAppVersion,
  setLanguage,
  setDeviceInfo,
  setFcmToken,
  setNotification,
} from 'modules/status';
import { KEY } from 'utils/constants/storageKey';
import { autoLogin } from 'modules/account';

/**   // =================== 네이티브(AOS, IOS) -> 웹뷰 통신 정의  =================== //  */
function useOnResultAction() {
  const dispatch = useDispatch();
  const setAppVersion = useSetRecoilState(appVersionState);
  window.onResultAction = (param, id, rawData) => {
    // param is language
    // rawData is {language : "ko"};
    let action = param;
    let data = rawData;
    let decodedParam = window.atob(param);

    // * IOS인 경우 데이터 프로세싱
    if (navigator.userAgent.indexOf('becon_ios') !== -1) {
      action = JSON.parse(decodedParam).action;
      data = JSON.stringify(JSON.parse(decodedParam).data);
    }

    console.group('onResultAction data');

    console.groupEnd();

    // * 두피 사진 촬영 (원격진료)
    if (action === 'MTakeTelemedicinePhoto') {
      console.log('last test : rawData >>>', data);
    }

    // * 소셜 로그인 (카카오)
    if (action === actionNames.loginAccount) {
      const kakaoUserData = JSON.parse(data);
      localStorage.setItem(KEY, data);
      sessionStorage.clear();
      dispatch(autoLogin(kakaoUserData));
      return;
    }

    // * 앱정보
    if (action === actionNames.getAppInfo || action === actionNames.appInfo) {
      setAppVersion(JSON.parse(data).current_version);
      // dispatch(setAppVersion(JSON.parse(data).current_version));
      return;
    }

    // * FCM 토큰 정보 (앱 푸시기능을 위한 FCM 토큰)
    if (action === actionNames.fcmTokenInfo) {
      dispatch(setFcmToken(JSON.parse(data).fcmToken));
      console.log('native 에서 받은 fcmToken data --> ', data);
    }

    // * 앱 알림 on/off (true/false)
    if (action === actionNames.notificationInfo) {
      dispatch(setNotification(JSON.parse(data).isAllowNotification));
      console.log('native 에서 받은 setNotification data--> ', data);
    }

    // * 기기 정보
    if (action === actionNames.deviceInfo) {
      const deviceInfo = JSON.parse(data);
      dispatch(setDeviceInfo(deviceInfo));
      return;
    }

    // * 앱 사용자설정 언어
    if (action === actionNames.getLanguage || action === actionNames.language) {
      if (
        JSON.parse(data).language === LANGUAGE.ko ||
        JSON.parse(data).language === LANGUAGE.kr
      ) {
        i18n.changeLanguage('ko');
        dispatch(setLanguage('ko'));
      } else if (JSON.parse(data).language === 'ja') {
        i18n.changeLanguage('ja');
        dispatch(setLanguage('ja'));
      } else if (JSON.parse(data).language === 'vi') {
        i18n.changeLanguage('vi');
        dispatch(setLanguage('vi'));
      } else if (JSON.parse(data).language === 'es') {
        i18n.changeLanguage('es');
        dispatch(setLanguage('es'));
      } else {
        i18n.changeLanguage('en');
        dispatch(setLanguage('en'));
      }
    }
  };
}

export default useOnResultAction;
